import { ApisClient } from "@dpdgroupuk/mydpd-app";

import { getApiOrigin } from "~/utils/config";

export default new ApisClient({
  fallbackBaseUrl: process.env.REACT_APP_CAB_API_URL,
});

export const APIS_ORIGIN_URL = getApiOrigin();
